import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  logoFacebook,
  logoLinkedin,
  logoTwitter,
  copyOutline,
} from 'ionicons/icons';


import {
  IonContent,
  IonIcon,
  IonRow,
  IonCol,
  IonButton,
  toastController,
} from '@ionic/vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ShareOptionsModal',
  props: {
    title: null,
    text: null,
    url: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  text: string;
  url: string;
}



const toastMessage = async (message: string) => {
  const toast = await toastController.create({
    message,
    duration: 1500,
    position: 'bottom',
  });

  await toast.present();
};

const copyToClipboard = async () => {
  await navigator.clipboard.writeText(props.url);

  await toastMessage('link copied!');
};

const shareTo = {
  facebook: 'https://www.facebook.com/sharer/sharer.php?u={URL}&via={VIA}',
  linkedin: 'https://www.linkedin.com/sharing/share-offsite?url={URL}',
  twitter:
    'https://twitter.com/intent/tweet?url={URL}&text={TEXT}&via={VIA}&related={RELATED}&title={TITLE}',
};

const getShareToLink = (shareType: string): string => {
  type ShareToKey = keyof typeof shareTo;
  const key = shareType as ShareToKey;

  return shareTo[key];
};

const onShare = (shareType: string) => {
  if (shareType === 'copy') {
    copyToClipboard();
  } else if (navigator.share) {
    navigator.share({
      title: props.title,
      text: props.text,
      url: props.url,
    });
  } else {
    const related = 'Goalkeeper,goalkeeper.com,learn.goalkeeper.com';
    const via = process.env.VUE_APP_APP_NAME.replace(/ /g, '_').toLowerCase();
    const link = getShareToLink(shareType)
      .replace('{URL}', encodeURI(props.url))
      .replace('{TITLE}', encodeURI(props.title.concat(':')))
      .replace('{TEXT}', encodeURI(props.text))
      .replace('{VIA}', encodeURI(via))
      .replace('{RELATED}', encodeURI(related));

    window.open(link, '_blank');
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonContent), { class: "ion-padding" }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRow), { class: "ion-justify-content-between" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCol), { size: "2" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButton), {
                shape: "round",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (onShare('facebook')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "icon-only",
                    icon: _unref(logoFacebook)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCol), { size: "2" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButton), {
                shape: "round",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (onShare('linkedin')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "icon-only",
                    icon: _unref(logoLinkedin)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCol), { size: "2" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButton), {
                shape: "round",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (onShare('twitter')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "icon-only",
                    icon: _unref(logoTwitter)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonCol), { size: "2" }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButton), {
                shape: "round",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (onShare('copy')))
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonIcon), {
                    slot: "icon-only",
                    icon: _unref(copyOutline)
                  }, null, 8, ["icon"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})